<template>
  <v-app>
    <transition name="slide-fade">
      <router-view/>
    </transition>
    <alertGroup />
  </v-app>
</template>

<script>
import alertGroup from '@/components/alert-group.vue'
import resize from '@/mixins/resize'

export default {
  name: 'App',
  mixins: [
    resize
  ],
  components: {
    alertGroup
  },

  data: () => ({
  }),

  mounted () {
    this.$store.dispatch('screen/check')
  },
  methods: {}
}
</script>
<style>

@font-face {
  font-family: mind524-font;
  src: url('./assets/fonts/GenJyuuGothic-Medium.ttf');
}

#html{
  box-sizing: content-box;

  overflow-y: auto;
  overflow-x: auto;
}

.slide-fade-enter-active {
  transition: all .8s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(50px);
  opacity: 0;
}
</style>
